<script setup lang="ts">
import { PV } from "@/widgets";

const props = defineProps<{
    isLoading?: boolean;
}>();
</script>

<template>
    <div class="flex flex-col w-screen items-center justify-center py-8">
        <div class="flex flex-col max-w-[960px] w-full">
            <div
                v-if="props.isLoading === true"
                class="rns-loading flex flex-col items-center justify-center gap-4 px-8"
            >
                <PV.ProgressBar class="w-1/2 h-2! rns-progress" mode="indeterminate" />
                <div>Memuat data ...</div>
            </div>
            <slot v-else></slot>
        </div>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-loading {
    @apply w-full h-full absolute top-0 left-0;
}

.rns-progress :deep(.p-progressbar-value) {
    @apply bg-black;
}
</style>
